import fetalMbtiIcon from "../../assets/fetal-mbti-logo.svg";

export default function FetalMbtiLauncher() {
  return (
    <div className="relative">
      <a
        href="https://v0-fetal-mbti-test.vercel.app/"
        target="_blank"
        rel="noopener noreferrer"
        className="relative flex flex-col items-center group"
        aria-label="태아 MBTI 예측"
      >
        <div
          className="
      mb-2
      rounded-full
      bg-white
      px-2 py-1
      text-sm
      font-extrabold
      text-[#de81c1]
      shadow
    "
        >
          태아 MBTI 예측
        </div>

        <div
          className="
            relative
        h-16 w-16
        sm:h-18 sm:w-18
        md:h-20 md:w-20
            rounded-full
            bg-white
            shadow-xl
            flex items-center justify-center
            transition
            duration-300
            group-hover:scale-105
          "
          style={{
            background:
              "linear-gradient(white, white) padding-box, linear-gradient(to bottom, #de81c1, #91dfcf) border-box",
            border: "4px solid transparent",
          }}
        >
          <img
            src={fetalMbtiIcon}
            alt="태아 MBTI 예측"
            className="h-[100%] w-[100%] object-contain select-none"
            draggable={false}
          />

          <span
            className="absolute -top-1 -right-1 h-3 w-3 rounded-full animate-ping"
            style={{ backgroundColor: "#de81c1" }}
          />
          <span
            className="absolute -top-1 -right-1 h-3 w-3 rounded-full"
            style={{ backgroundColor: "#de81c1" }}
          />
        </div>
      </a>
    </div>
  );
}
